import request from '@/utils/request'

// 账号密码登录
export function passwordLogin(data) {
  return request({
    url: '/equipment/member/passwordLogin',
    method: 'post',
    data
  })
}


// 验证码登录
export function codeLogin(data) {
  return request({
    url: '/equipment/member/codeLogin',
    method: 'post',
    data
  })
}

// 忘记密码
export function forgetPassword(data) {
  return request({
    url: '/equipment/member/forgetPassword',
    method: 'post',
    data
  })
}

// 注册
export function register(data) {
  return request({
    url: '/equipment/member/register',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfo(query) {
  return request({
    url: '/equipment/member/memberInfo',
    method: 'get',
    query
  })
}

// 成为企业账号
export function becomeFirm(data) {
  return request({
    url: '/equipment/member/becomeFirm',
    method: 'post',
    data
  })
}


// 查询店铺信息
export function getFirmInfo(query) {
  return request({
    url: '/equipment/firm/firmInfo',
    method: 'get',
    query
  })
}


// 编辑店铺信息
export function editFirm(data) {
  return request({
    url: '/equipment/firm/editFirm',
    method: 'post',
    data
  })
}

// 实名认证
export function applyRealName(data) {
  return request({
    url: '/equipment/real/applyReal',
    method: 'post',
    data
  })
}


// 新增或编辑地址
export function saveOrUpdateAddress(data) {
  return request({
    url: '/equipment/address/saveOrUpdate',
    method: 'post',
    data
  })
}



// 获取默认收货地址
export function getDefaultAddress(data) {
  return request({
    url: '/equipment/address/getDefaultAddress',
    method: 'post',
    data
  })
}


// 查询收藏列表
export function getCollectList(query) {
  return request({
    url: '/equipment/collect/list',
    method: 'get',
    params: query
  })
}


// 提现
export function withdrawalApply(data) {
  return request({
    url: '/equipment/member/withdrawalApply',
    method: 'post',
    data
  })
}

// 提现明细
export function balanceList(data) {
  return request({
    url: '/equipment/member/balanceList',
    method: 'post',
    data
  })
}


// 修改密码
export function updatePassword(data) {
  return request({
    url: '/equipment/member/updatePassword',
    method: 'post',
    data
  })
}

//获取小程序二维码
export function getQRImg(data) {
  return request({
    url: '/equipment/member/getQRImg',
    method: 'post',
    data
  })
}

//PC微信授权
export function wxPcOauth(data) {
  return request({
    url: '/equipment/member/wxPcOauth',
    method: 'post',
    data
  })
}
//根据unionId微信登录
export function wxLoginByUnionId(data) {
  return request({
    url: '/equipment/member/wxLoginByUnionId',
    method: 'post',
    data
  })
}

//商品统计个人中心
export function productCont(data) {
  return request({
    url: '/equipment/product/productCont',
    method: 'post',
    data
  })
}
//更改营业执照
export function businessLicense(data) {
  return request({
    url: '/equipment/firm/updateInfo',
    method: 'post',
    data
  })
}


